import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PaymentVoucherState } from "./voucher.types";
import { voucherApi } from "./voucher.api";
import { withErrorHandler } from "../../app/core-slice";

const initialState: PaymentVoucherState = {
    filter: {
        searchTerm: "",
    },
    searchResults: {
        items: [],
        total: 0,
    },
    searchInprogress: false,
};

export const fetchVouchersAsync = createAsyncThunk(
    "voucher/fetchVoucherList",
    withErrorHandler(voucherApi.searchVouchers)
);

export const fetchVoucherAsync = createAsyncThunk("voucher/fetchVoucher", withErrorHandler(voucherApi.getVoucher));

const voucherSlice = createSlice({
    name: "invoice",
    initialState,
    reducers: {
        setVouchersFilter(state, action: PayloadAction<any>) {
            state.filter = { ...state.filter, ...action.payload };
        },
        setCreateNewVoucher(state, action: PayloadAction<boolean>) {
            state.createNew = action.payload;
        },
        clearEditingVoucher(state) {
            state.editingVoucher = undefined;
            state.createNew = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVouchersAsync.pending, (state) => {
                state.searchInprogress = true;
            })
            .addCase(fetchVouchersAsync.fulfilled, (state, action) => {
                state.searchResults = action.payload;
                state.searchInprogress = false;
            })
            .addCase(fetchVouchersAsync.rejected, (state) => {
                state.searchInprogress = false;
            })
            .addCase(fetchVoucherAsync.pending, (state) => {
                state.editingVoucher = undefined;
            })
            .addCase(fetchVoucherAsync.fulfilled, (state, action) => {
                state.editingVoucher = action.payload;
            })
            .addCase(fetchVoucherAsync.rejected, (state) => {
                state.editingVoucher = undefined;
            });
    },
});

export const { setVouchersFilter, setCreateNewVoucher, clearEditingVoucher } = voucherSlice.actions;

export default voucherSlice.reducer;

//Selectors
export const selectVoucherFilter = (state: RootState) => state.voucher.filter;
export const selectVoucherSearchResults = (state: RootState) => state.voucher.searchResults;
export const selectVoucherSearchInprogress = (state: RootState) => state.voucher.searchInprogress;
export const selectEditingVoucher = (state: RootState) => state.voucher.editingVoucher;
export const selectCreateNewVoucher = (state: RootState) => state.voucher.createNew;
